var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-title"},[_vm._v("Medium-Term Strategy for 2022-2029")]),_c('iframe',{staticClass:"pdf-iframe",staticStyle:{"display":"block"},attrs:{"src":"/Medium-Term Strategy for 2022-2029 (41 C4)_eng.pdf","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }